/** Wall-clock budgets. The browser leaves time for the Worker to return its error. */
export const API_TIMEOUT_MS = 25_000;
export const CLIENT_TIMEOUT_GRACE_MS = 10_000;
/** A draft streams until this, then fails: a cut-off draft is never salvaged (KTD4). */
export const DRAFT_DEADLINE_MS = 75_000;
/** The handler's bound on the draft call: past the model's deadline, so the adapter answers first. */
export const DRAFT_PIPELINE_TIMEOUT_MS = 80_000;
/** Learning Commons paging for the full course set, before the model starts. */
export const STANDARDS_LOAD_TIMEOUT_MS = 30_000;
/** The draft route's whole budget: standards, then the model, then the store. */
export const DRAFT_REQUEST_TIMEOUT_MS = 120_000;
/** Start blank pages the course's standards and then stores the plan; no model call. */
export const BLANK_REQUEST_TIMEOUT_MS = 45_000;
/** An upload to Collab: up to 10 MB through two Workers, inside Collab's 30 s (KTD1, KTD5). */
export const COLLAB_UPLOAD_REQUEST_TIMEOUT_MS = 45_000;

/**
 * One request's whole budget. The Worker's deadline and the browser's `call()` both read it,
 * so the two cannot disagree about which requests are long.
 */
export function requestBudgetMs(method: string | undefined, path: string): number {
  if (method !== 'POST') return API_TIMEOUT_MS;
  if (path === '/api/plans/draft') return DRAFT_REQUEST_TIMEOUT_MS;
  if (path === '/api/plans') return BLANK_REQUEST_TIMEOUT_MS;
  if (/^\/api\/plans\/[^/]+\/collab-uploads$/.test(path)) return COLLAB_UPLOAD_REQUEST_TIMEOUT_MS;
  return API_TIMEOUT_MS;
}
/** A unit's topic searches, inside the GET budget; past it the list comes back marked for retry. */
export const TOPICS_SEARCH_TIMEOUT_MS = 15_000;
